import { Component, EventEmitter, Input, Output } from '@angular/core';

import { CmpsScorecardSubHeaderData } from './scorecard-sub-header.metadata';

@Component({
    selector: 'cmps-scorecard-sub-header',
    template: `
        <div class="cmps-scorecard-sub-header--container">
            <div class="cmps-scorecard-sub-header--labels">
                <h5 class="cmps-scorecard-sub-header--label">
                    {{ superGroupLabel }} {{ superGroupValue }}
                </h5>
                <h5 class="cmps-scorecard-sub-header--label">
                    {{ scorecardId }} {{ scorecardValue }}
                </h5>
            </div>
            <div class="cmps-scorecard-sub-header--period-type">
                <select
                    class="cmps-scorecard-sub-header--menu"
                    [disabled]="disabled"
                    [ngModel]="selected"
                    (ngModelChange)="
                        selected = $event; selectedAction.emit($event)
                    "
                >
                    <option *ngFor="let i of options">
                        {{ i.value }}
                    </option>
                </select>
                <cmps-icon svgIcon="__internal:chevron-down"></cmps-icon>
            </div>
        </div>
    `,
    host: {
        class: 'cmps-scorecard-sub-header',
    },
})
export class CmpsScorecardSubHeaderComponent {
    @Input() superGroupLabel: string;
    @Input() superGroupValue: string;
    @Input() scorecardId: string;
    @Input() scorecardValue: string;

    @Input() selected: string;
    @Input() disabled: boolean;
    @Input() options: CmpsScorecardSubHeaderData[];

    @Output() selectedAction: EventEmitter<string>;

    constructor() {
        this.selectedAction = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.selectedAction.complete();
    }
}
